var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-section-loader',
    ("dp-section-loader--size-" + _vm.size),
    {
      'dp-section-loader--active': _vm.active,
    } ]},[_c('dp-separator'),_c('dp-spinner-loader',{staticClass:"dp-section-loader__spinner",attrs:{"size":_vm.spinnerSize}}),_c('dp-separator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }